/**
 * @generated SignedSource<<6d5ee8c5251b3f13a4edb5d755d7218b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleSettingsScreenComponentTask_task$data = {
  readonly routine: {
    readonly " $fragmentSpreads": FragmentRefs<"ListSectionHeaderRoutine_Routine">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TaskListItemIcon_Task" | "TaskListItemTitle_Task">;
  readonly " $fragmentType": "WidgetTaskSingleSettingsScreenComponentTask_task";
};
export type WidgetTaskSingleSettingsScreenComponentTask_task$key = {
  readonly " $data"?: WidgetTaskSingleSettingsScreenComponentTask_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleSettingsScreenComponentTask_task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskSingleSettingsScreenComponentTask_task",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskListItemIcon_Task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskListItemTitle_Task"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListSectionHeaderRoutine_Routine"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": "__isTask"
};

(node as any).hash = "2957884a8449816cf8bab92da20dc6a7";

export default node;
